export default __webpack_public_path__ + "static/media/Archivo-Regular.7ede9f23.woff2";